import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { IconContext } from 'react-icons';

import { IoInformationCircle } from 'react-icons/io5';

export default function AccessibilitySettings() {
  const [values, setValues] = useState([
    false, //monochrome
    false, //high-contrast
    false, //highlight-links
    false, //increase-font-size
  ]);

  const OptionSwitch = ({ text, optionIndex }) => {
    return (
      <div className="d-flex gap-3 mb-3 w-100 justify-content-center align-items-center justify-content-sm-start">
        <div style={{ width: 134 }}>{text}</div>
        <button
          className="d-flex rounded-2"
          style={{
            width: 50,
            backgroundColor: 'grey',
          }}
          onClick={() => {
            const temp = values.map((item, index) => {
              if (index === optionIndex) return !item;
              else return item;
            });
            setValues([...temp]);
          }}
        >
          <div
            className="rounded-2"
            style={{
              width: 25,
              height: 25,
              backgroundColor: values[optionIndex] ? 'lightgrey' : 'grey',
            }}
          />
          <div
            className="rounded-2"
            style={{
              width: 25,
              height: 25,
              backgroundColor: values[optionIndex] ? 'grey' : 'lightgrey',
            }}
          />
        </button>
      </div>
    );
  };

  return (
    <div className="w-100 h-100 d-flex align-items-center justify-content-center justify-content-sm-start mt-3">
      <div className="d-flex flex-column align-items-center align-items-sm-start w-100">
        <div className="d-flex flex-column flex-sm-row text-white align-items-center">
          <IconContext.Provider value={{ size: 30 }}>
            <IoInformationCircle />
          </IconContext.Provider>
          <p className="fs-6 text-center m-0">These settings apply per user</p>
        </div>
        <OptionSwitch text={'Monochrome'} optionIndex={0} />
        <OptionSwitch text={'High Contrast'} optionIndex={1} />
        <OptionSwitch text={'Highlight Links'} optionIndex={2} />
        <OptionSwitch text={'Increase Font Size'} optionIndex={3} />
      </div>
    </div>
  );
}
